<template>
    <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
            Lägg till pass
        </v-card-title>

        <v-card-text>
            <v-row>
                <v-col cols="2">
                    <v-btn icon @click="subtractDay" v-if="currentDate >= new Date()">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="8">
                    <div class="text-center">
                        {{ currentDate.toLocaleDateString("sv-SE", { weekday: "long", month: "long", day: "numeric" }) }}
                    </div>
                </v-col>
                <v-col cols="2">
                    <v-btn icon @click="addDay">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0">
                    <v-checkbox
                        label="Hela dagen"
                        v-model="wholeDay"
                        class="pa-0 ma-0" />
                </v-col>
            </v-row>
            <v-row v-if="wholeDay === false">
                <v-col cols="2" class="pa-0 ma-0">
                    Starttid
                </v-col>
                <v-col cols="5" class="pa-0 ma-0">
                    <v-select
                        label="Timme"
                        :items="hours" 
                        v-model="startHour"
                        class="py-0 px-2 ma-0" />
                </v-col>
                <v-col cols="5" class="pa-0 ma-0">
                    <v-select 
                        label="Minut"
                        :items="minutes"
                        v-model="startMinute"
                        class="py-0 px-2 ma-0" />
                </v-col>
            </v-row>
            <v-row v-if="wholeDay === false">
                <v-col cols="2" class="pa-0 ma-0">
                    Sluttid
                </v-col>
                <v-col cols="5" class="pa-0 ma-0">
                    <v-select :items="hours" label="Timme" class="py-0 px-2 ma-0" />
                </v-col>
                <v-col cols="5" class="pa-0 ma-0">
                    <v-select :items="minutes" label="Minut" class="py-0 px-2 ma-0" />
                </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0">
                    <v-checkbox 
                        label="Upprepa sju dagar framåt?"
                        v-model="repeatSevenDays"
                        class="pa-0 ma-0" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="pa-0 ma-0">
                    <v-text-field 
                        label="Kommentar" 
                        v-model="comment"
                        class="py-0 px-2 ma-0" />
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-btn @click="closeDialog">Avbryt</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="closeDialog">Lägg till</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: { 'closeDialog': Function },
    data() {
        return {
            currentDate: new Date(),
            wholeDay: false,
            startHour: null,
            startMinute: null,
            endHour: null,
            endMinute: null,
            repeatSevenDays: false,
            comment: null,
            hours: [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23
            ],
            minutes: [0, 15, 30, 45]
        };
    },
    computed: {
        humanDate: function() {
            const options = { weekday: "long", month: "long", day: "numeric" };
            return this.currentDate.toLocaleDateString("sv-SE", options);
        }
    },
    methods: {
        addDay: function() {
            let date = this.currentDate
            date.setDate(date.getDate() + 1)
            this.currentDate = date
            this.$forceUpdate()
        },
        subtractDay: function() {
            let date = this.currentDate
            date.setDate(date.getDate() - 1)
            this.currentDate = date
            this.$forceUpdate()
        }
    }
};
</script>